import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white py-12 md:py-16 border-t border-white/10" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-110">
        <div className="mb-8" data-id="element-111">
          <img src="https://cdn.magicpatterns.com/uploads/1t5KrLSHk2kgV3QLTxB2A5/slater-elite.png" alt="S.E.P. Logo" className="h-24 w-24 md:h-32 md:w-32 object-contain mx-auto" data-id="element-112" />
        </div>

        <h2 className="font-heading font-black text-2xl md:text-3xl tracking-widest uppercase mb-8 text-white" data-id="element-113">
          STRIVE. EXCEL. PREVAIL.
        </h2>

        <nav className="flex flex-wrap justify-center gap-6 md:gap-10 mb-10" data-id="element-114">
          <a href="#home" className="text-gray-400 hover:text-sep-red font-medium transition-colors uppercase text-sm tracking-wider" data-id="element-115">
            Home
          </a>
          <a href="#programs" className="text-gray-400 hover:text-sep-red font-medium transition-colors uppercase text-sm tracking-wider" data-id="element-116">
            Programs
          </a>
          <a href="#services" className="text-gray-400 hover:text-sep-red font-medium transition-colors uppercase text-sm tracking-wider" data-id="element-117">
            Services
          </a>
          <a href="#about" className="text-gray-400 hover:text-sep-red font-medium transition-colors uppercase text-sm tracking-wider" data-id="element-118">
            About
          </a>
          <a href="#contact" className="text-gray-400 hover:text-sep-red font-medium transition-colors uppercase text-sm tracking-wider" data-id="element-119">
            Contact
          </a>
        </nav>

        <div className="flex gap-6 mb-10" data-id="element-120">
          <a href="#" className="text-gray-400 hover:text-sep-red transition-colors" data-id="element-121">
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" data-id="element-122">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-123" />
            </svg>
            <span className="sr-only" data-id="element-124">TikTok</span>
          </a>
          <a href="#" className="text-gray-400 hover:text-sep-red transition-colors" data-id="element-125">
            <Instagram className="w-6 h-6" data-id="element-126" />
            <span className="sr-only" data-id="element-127">Instagram</span>
          </a>
          <a href="#" className="text-gray-400 hover:text-sep-red transition-colors" data-id="element-128">
            <Facebook className="w-6 h-6" data-id="element-129" />
            <span className="sr-only" data-id="element-130">Facebook</span>
          </a>
        </div>

        <div className="w-full border-t border-white/10 pt-8" data-id="element-131">
          <p className="text-gray-500 text-sm" data-id="element-132">
            &copy; {new Date().getFullYear()} Slater Elite Performance. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}